export default "__VITE_ASSET__bzdkjRyK__"